export default function MetricCard({ value, label, detail }) {
  return (
    <div className="text-center">
      <div className="text-4xl md:text-5xl font-bold text-white mb-1">{value}</div>
      <div className="text-lg text-blue-100 font-medium">{label}</div>
      {detail && <div className="text-sm text-blue-200 mt-1">{detail}</div>}
    </div>
  );
}
